import Vue from 'vue'
import Router from 'vue-router'

import CreateAnalyzerFlow from '@/components/CreateModelFlow/CreateAnalyzerFlow'
import AnalyzerType from '@/components/CreateModelFlow/AnalyzerType'
import AnalyzerSources from '@/components/CreateModelFlow/AnalyzerSources'
import AnalyzerSummary from '@/components/CreateModelFlow/AnalyzerSummary'
import AnalyzerBuild from '@/components/CreateModelFlow/AnalyzerBuild'

import Models from '@/components/Models'
import Model from '@/components/Model'
import Login from '@/components/Login.vue'
import Register from '@/components/Register.vue'
import ValidateEmail from '@/components/ValidateEmail.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/models/create',
      name: 'CreateAnalyzerFlow',
      component: CreateAnalyzerFlow,
      redirect: '/models/create/models_type',
      children: [
        {
          path: '/models/create/models_type',
          name: 'AnalyzerType',
          component: AnalyzerType
        },
        {
          path: '/models/create/models_sources',
          name: 'AnalyzerSources',
          component: AnalyzerSources
        },
        {
          path: '/models/create/models_summary',
          name: 'AnalyzerSummary',
          component: AnalyzerSummary
        },
        {
          path: '/models/create/models_build',
          name: 'AnalyzerBuild',
          component: AnalyzerBuild
        }
      ]
    },
    {
      path: '/models',
      name: 'Models',
      component: Models
    },
    {
      path: '/models/:id',
      name: 'Model',
      component: Model
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/register',
      name: 'Register',
      component: Register
    },
    {
      path: '/validate-email/:token',
      name: 'ValidateEmail',
      component: ValidateEmail
    },
    {
      path: '/',
      redirect: '/models'
    }
  ],
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js